import { useState } from "react"

export const useModal = () => {
	const [isOpen, setOpen] = useState(false)
	const toggle = () => {setOpen(!isOpen)}
	const shutDown = () => {setOpen(false)}
	const show = () => {setOpen(true)}
	return { toggle, show, shutDown, isOpen }
}
